import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Item_Seleccion } from 'src/app/models/generic/Item_Seleccion';
import { ConfiguracionService } from 'src/app/services/configuracion.service';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { ProductosService } from 'src/app/services/productos.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';

@Component({
  selector: 'modificar-plantilla',
  templateUrl: './modificar-plantilla.component.html',
  styleUrls: ['./modificar-plantilla.component.scss']
})
export class ModificarPlantillaComponent implements OnInit{
  @Input() TituloMostrar: string = 'Modificar plantilla Html';
  @Input() TextoSiMostrar: string = 'Aceptar';
  @Input() TextoNoMostrar: string = 'Cancelar';
  @Output() ConfirmoUsuario: EventEmitter<string>;
  @ViewChild('modaledicionhtml', {static: false}) _ModalConfirmacion: TemplateRef<any>;
  form: FormGroup;
  _ContenidoHtml: string = '';
  
  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public menuService: MenuService,
    public productosService: ProductosService,
    public configuracionService: ConfiguracionService,
    public modal: MatDialog) {
      this.ConfirmoUsuario = new EventEmitter();
    }

  ngOnInit() {
    this.IniciarFormulario();
  }

  public MostrarEdicionHtml(textoProcesar: string) {
    this.IniciarFormulario();
    this.form.get('contenidoHtml').setValue(textoProcesar);
    this._ContenidoHtml = textoProcesar;

    let confirmacionModal = this.modal.open(this._ModalConfirmacion, {
      width: '95%',
      height: '80%'
    });

    confirmacionModal.afterClosed().subscribe(valor => {
      if (valor) {
        this.ConfirmoUsuario.emit(this._ContenidoHtml);
      } else {
        this.ConfirmoUsuario.emit('');
      }
    });
  }

  IniciarFormulario() {
    this.form = this.fb.group({
      contenidoHtml: ['']
    });

    this.form.get('contenidoHtml').valueChanges.subscribe((valorNuevo) => {
      this._ContenidoHtml = valorNuevo;
    });
  }
}
